module.exports = __webpack_public_path__ + "static/media/ubq.d17d3545.svg";